/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_ii as ii,
} from "../../runtime/index.jsx";
export function Componente_bZ_98_90() {
  let e = (0, ReactCompiler.c)(1),
    t;
  return (
    e[0] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((t = (
          <div
            className={`flex items-center gap-2 text-sm text-(--text)`}
            children={[
              (0, JSXRuntime.jsx)(ii, {
                className: `h-4 w-4 animate-spin`,
              }),
              ` Cargando…`,
            ]}
          />
        )),
        (e[0] = t))
      : (t = e[0]),
    t
  );
}
